import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ShareGameComponent } from './share-game/share-game.component';
import { SharingComponent } from './sharing.component';
import { AuthGuard } from 'src/app/core/guards/auth.guard';

const routes: Routes = [
  {
    path: 'sharing',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'sharing',
    component: SharingComponent,
    children: [
      {
        path: 'game/:id',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./share-game/share-game.module').then(
            (m) => m.ShareGameModule,
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SharingRoutingModule {}
